




































































import { Component, Mixins, Prop } from 'vue-property-decorator';
import MessageMixin from './Message';
import ImagePrivate from '@/components/common/ImagePrivate.vue';
import LazyloadImage from '@/components/image/LazyloadImage.vue';

@Component({
  components: {
    ImagePrivate,
    LazyloadImage,
  },
})
export default class MessageImage extends Mixins(MessageMixin) {
  @Prop() avatarUser!: any;
  @Prop() avatarManager!: any;
  @Prop() readonly isHovered!: boolean;
  @Prop({type: Number, default: null}) readonly lastPatientReadMessageId!: number | null;

  isMenuOpen: boolean = false;

  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  }

  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  handleClickOutside(e: MouseEvent) {
    const menu = this.$refs.actionMenu as HTMLElement;
    if (menu && !menu.contains(e.target as Node)) {
      this.isMenuOpen = false;
    }
  }

  handleHideMenuAction() {
    this.$emit('hover', null);
    this.isMenuOpen = false;
  }
}
